import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { MapData } from 'teacher-ui-client/reporting/ui-scope/re/student-summary/course-progress/reading/template'
import type { StudentScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface ReadingMapsDetailsResponse {
  reading_map_details: {
    created_at: number
    correct_count: number
    map_number: number
    total_count: number
    attempts: number
    categories: {
      name: string
      areas: { correct: string[]; incorrect: string[]; name: string }[]
    }[]
    latest_passed_quiz: Nullable<{
      created_at: number
      correct_count: number
      total_count: number
    }>
  }[]
}

export async function readingMapDetails(
  this: StudentEventsService,
  product: LegacyProductRe,
  statsScope: StudentScope,
  period: NormalizedInterval,
): Promise<Nullable<MapData[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('reading_map_details', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<ReadingMapsDetailsResponse>(url, query)
  if (!data) return null

  const { reading_map_details } = data
  if (reading_map_details.length === 0) return null

  return reading_map_details
}
